import { DownloadIcon } from '@heroicons/react/outline';
import React, { FC } from 'react';
import Button from 'components/Button';

interface ITableExport {
  rowSelected: any[];
}

const TableExport: FC<ITableExport> = ({ rowSelected }) => {
  return (
    <Button
      type="button"
      variant="green-primary"
      classNameButton="space-x-2"
      disabled={rowSelected.length === 0}
    >
      <DownloadIcon className="h-5 w-5 " />
      <span>Export</span>
    </Button>
  );
};

export default TableExport;
